import { c as _c } from "react/compiler-runtime";
import { Button, Heading, Picture, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import Link from 'next/link';
import { ContentfulClick } from '@libs/analytics';
import { COLOR_TABLE, NEW_TAB, PRIMARY_BUTTON_STYLE, SECONDARY_BUTTON_STYLE, TARGET_BLANK, TARGET_SELF } from '../../constants';
import { cutText } from '../../utils/cutText';
import { propsImageItems } from '../../utils/propsImagesItems';
import { type CampaignHeroVariantProps } from './types';
import './CampaignHeroSplit.scss';
export default function CampaignHeroSplit(t0) {
  const $ = _c(49);
  const {
    preheader,
    header,
    body,
    cta,
    primaryTextColor,
    secondaryTextColor: t1,
    background,
    image,
    internalTitle,
    isH1
  } = t0;
  const secondaryTextColor = t1 === undefined ? "Dark Grey" : t1;
  let t2;
  if ($[0] !== image) {
    t2 = propsImageItems(image);
    $[0] = image;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const imageItems = t2;
  const t3 = COLOR_TABLE[primaryTextColor];
  let t4;
  if ($[2] !== t3) {
    t4 = {
      color: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const primaryColorStyle = t4;
  const t5 = COLOR_TABLE[secondaryTextColor];
  let t6;
  if ($[4] !== t5) {
    t6 = {
      color: t5
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const secondaryColorStyle = t6;
  const WrapperComponent = cta ? Link : "div";
  const t7 = cta?.link.webUrl || "";
  const t8 = cta?.behavior === NEW_TAB ? TARGET_BLANK : TARGET_SELF;
  const t9 = cta?.text;
  let t10;
  if ($[6] !== body || $[7] !== header || $[8] !== preheader || $[9] !== t9) {
    t10 = cn(preheader, header, body, t9);
    $[6] = body;
    $[7] = header;
    $[8] = preheader;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = cta?.link.webUrl ?? "";
  let t12;
  if ($[11] !== header || $[12] !== internalTitle || $[13] !== t10 || $[14] !== t11) {
    t12 = {
      linkText: t10,
      linkUrl: t11,
      promoTitle: header,
      promoVariant: "campaign hero - split",
      promoDesc: internalTitle,
      promoType: "campaign-hero-split"
    };
    $[11] = header;
    $[12] = internalTitle;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== background) {
    t13 = background && {
      background
    };
    $[16] = background;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t13) {
    t14 = {
      ...t13
    };
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== preheader || $[21] !== secondaryColorStyle) {
    t15 = preheader && <TextPassage className="preheader" style={secondaryColorStyle}>{preheader}</TextPassage>;
    $[20] = preheader;
    $[21] = secondaryColorStyle;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  const t16 = isH1 ? "h1" : "h2";
  let t17;
  if ($[23] !== header || $[24] !== primaryColorStyle || $[25] !== t16) {
    t17 = <Heading className="campaign-hero-split__header" tagName={t16} style={primaryColorStyle}>{header}</Heading>;
    $[23] = header;
    $[24] = primaryColorStyle;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== body || $[28] !== secondaryColorStyle) {
    t18 = body && <TextPassage style={secondaryColorStyle}>{cutText(body, 40)}</TextPassage>;
    $[27] = body;
    $[28] = secondaryColorStyle;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== cta) {
    t19 = cta && <Button variant={cta.buttonStyle.toLowerCase() === "primary" ? PRIMARY_BUTTON_STYLE : SECONDARY_BUTTON_STYLE} text={cta.text} fullWidth={false} size="lg" />;
    $[30] = cta;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t14 || $[33] !== t15 || $[34] !== t17 || $[35] !== t18 || $[36] !== t19) {
    t20 = <div className="campaign-hero-split__info-container" style={t14}>{t15}{t17}{t18}{t19}</div>;
    $[32] = t14;
    $[33] = t15;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  const t21 = imageItems[0]?.srcSet;
  let t22;
  if ($[38] !== image.webAltText || $[39] !== imageItems || $[40] !== t21) {
    t22 = <Picture imgAlt={image.webAltText} imgSrc={t21} items={imageItems} />;
    $[38] = image.webAltText;
    $[39] = imageItems;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== WrapperComponent || $[43] !== t12 || $[44] !== t20 || $[45] !== t22 || $[46] !== t7 || $[47] !== t8) {
    t23 = <ContentfulClick component={WrapperComponent} className="campaign-hero-split" href={t7} target={t8} prefetch={false} eventData={t12}>{t20}{t22}</ContentfulClick>;
    $[42] = WrapperComponent;
    $[43] = t12;
    $[44] = t20;
    $[45] = t22;
    $[46] = t7;
    $[47] = t8;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  return t23;
}